import * as angular from "angular";

export class ActivityService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/activity";
    }

    all(params: { filter: any; offset: any }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/all`, { params: params });
    }

    house(params: { id: string | number }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/house/${params.id}`, {
            params: params,
        });
    }

    houseoccupant(params: {
        id: string;
        filter: any;
        offset: any;
    }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/houseoccupant/${params.id}`, {
            params: params,
        });
    }

    location(params: { id: string | number }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/location/${params.id}`, {
            params: params,
        });
    }
}

angular.module("vcServices", []).service("ActivityService", ActivityService);
